module.exports = __webpack_public_path__ + "static/media/maxilofacial.b35ca875.png";